@if (isLoading()) {
  <palantir-skeleton class="palantir-map" />
}

<div class="palantir-map" #map [class.palantir-hidden]="isLoading()"></div>
